import React from 'react'

function HumanIcon() {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="15" fill="#00AEEF" />
      <path
        d="M20.3337 21V19.6667C20.3337 18.9594 20.0527 18.2811 19.5526 17.781C19.0525 17.281 18.3742 17 17.667 17H12.3337C11.6264 17 10.9481 17.281 10.448 17.781C9.94794 18.2811 9.66699 18.9594 9.66699 19.6667V21"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9997 14.3333C16.4724 14.3333 17.6663 13.1394 17.6663 11.6667C17.6663 10.1939 16.4724 9 14.9997 9C13.5269 9 12.333 10.1939 12.333 11.6667C12.333 13.1394 13.5269 14.3333 14.9997 14.3333Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default HumanIcon
